import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiMail, FiUser, FiHeart } = FiIcons;

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-white py-12">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="grid md:grid-cols-3 gap-8 mb-8"
        >
          <div>
            <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
              <SafeIcon icon={FiMail} className="text-blue-400" />
              Contacto
            </h4>
            <a 
              href="mailto:hola@nutretualma.com"
              className="text-blue-400 hover:text-blue-300 transition-colors"
            >
              hola@nutretualma.com
            </a>
          </div>
          
          <div>
            <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
              <SafeIcon icon={FiUser} className="text-blue-400" />
              Nuestros Expertos
            </h4>
            <div className="space-y-2 text-gray-300">
              <p>Dr. Brian Llánez Araya</p>
              <p>Dr. Juan Carlos Alba Maldonado</p>
            </div>
          </div>
          
          <div>
            <h4 className="text-xl font-bold mb-4 flex items-center gap-2">
              <SafeIcon icon={FiHeart} className="text-blue-400" />
              República Nutritiva
            </h4>
            <p className="text-gray-300">Una marca de Nutre tu Alma</p>
          </div>
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="border-t border-gray-700 pt-8 text-center text-gray-400"
        >
          <p>© Todos los derechos reservados. Nutre tu Alma | Política de privacidad</p>
        </motion.div>
      </div>
    </footer>
  );
};

export default Footer;